/** @jsxImportSource @emotion/react */
import { inputStyle } from './Input.styles';

/** 입력 종류. admin-mockup에서 password(로그인), date(이력 필터) 확인되어 확장. */
export type InputType = 'text' | 'password' | 'date';

export interface InputProps {
  type?: InputType;
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
}

/** 한 줄 입력. 필터 검색, 로그인 폼, 날짜 선택에 활용. */
export function Input({ type = 'text', placeholder, value, onChange }: InputProps) {
  return (
    <input
      type={type}
      css={inputStyle}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
    />
  );
}
